import React from "react";
import { Clock } from "lucide-react";
import { formatDiagnosticDate } from "../../../utils/dateFormatter";

function PLCStatus({ diagnosticData }) {
  // Extract and format the SystemTimestamp safely
  const rawTimestamp = diagnosticData?.plcStatus?.[0]?.SystemTimestamp;
  const systemTimestamp = formatDiagnosticDate(rawTimestamp);

  return (
    <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 flex flex-col items-center justify-center text-center">
      <div className="flex items-center justify-center gap-2">
        <Clock className="text-blue-500" size={20} />
        <h3 className="text-lg font-bold text-gray-800">Last Updated Date</h3>
      </div>
      <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
        {systemTimestamp}
      </div>
    </div>
  );
}

export default PLCStatus;

